import React from 'react';

interface IDownloadProps {
    width?: number;
    height?: number;
    color?: string;
}

export const Download = ({ width = 32, height = 32, color = '#252733' }: IDownloadProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
    >
        <g clipPath="url(#clip0_956_6023)">
            <path
                d="M7.01866 11.0833C7.24852 11.0834 7.47614 11.0383 7.68853 10.9504C7.90092 10.8625 8.09392 10.7336 8.2565 10.5712L10.5426 8.28333L9.71775 7.46083L7.5985 9.58067L7.58333 0H6.41666L6.43183 9.57133L4.32016 7.45967L3.49533 8.28333L5.78141 10.5694C5.94378 10.7321 6.13662 10.8613 6.34891 10.9495C6.5612 11.0376 6.78879 11.0831 7.01866 11.0833Z"
                fill={color}
            />
            <path
                d="M12.8333 9.33337V12.25C12.8333 12.4047 12.7719 12.5531 12.6625 12.6625C12.5531 12.7719 12.4047 12.8334 12.25 12.8334H1.75C1.59529 12.8334 1.44692 12.7719 1.33752 12.6625C1.22812 12.5531 1.16667 12.4047 1.16667 12.25V9.33337H0V12.25C0 12.7142 0.184374 13.1593 0.512563 13.4875C0.840752 13.8157 1.28587 14 1.75 14H12.25C12.7141 14 13.1592 13.8157 13.4874 13.4875C13.8156 13.1593 14 12.7142 14 12.25V9.33337H12.8333Z"
                fill={color}
            />
        </g>
    </svg>
);
